import { ShiftTimeRangeInputLegendReducerState } from './types';

export const getDefaultState = (): ShiftTimeRangeInputLegendReducerState => ({
  isOpened: false
});
